import { render } from "./Header.vue?vue&type=template&id=50a74c64&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=50a74c64&lang=scss&scoped=true"

import exportComponent from "E:\\_projekte\\PRIGNITZMUSEUM_HAVELBERG\\ARCHITEKTURSPUR\\release\\architekturspur\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a74c64"]])

export default __exports__